/**
 * These values are used to fetch optimized quiz image from our image service.
 * They are not random, we checked that they're already in use in other modules (e.g. recirculation pre-footer).
 * In order not to waste bandwidth we use the same values for the quiz image.
 */
export const quizImageParamsDesktop = {
    width: 236,
    height: 236,
    mode: 'smart',
};
export const quizImageParamsMobile = {
    width: 386,
    height: 259,
    mode: 'smart',
};
